import { style } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';
import { reducedMotion } from '../../theme/media';

export const wrapper = style({
  position: 'relative',
  display: 'inline-block',
});

export const trigger = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '4px 8px',
  border: `1px solid ${vars.surface.liquidGlass.innerSurface.border}`,
  borderRadius: vars.spacing.borderRadius.sm,
  background: vars.surface.liquidGlass.innerSurface.background,
  color: vars.typography.textColor.primary,
  fontSize: vars.typography.fontSize.xs,
  cursor: 'pointer',
  transition: `border-color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
  selectors: {
    '&:hover:not(:disabled)': {
      borderColor: vars.surface.border.accent,
    },
    '&:disabled': {
      opacity: '0.5',
      cursor: 'not-allowed',
    },
  },
  '@media': {
    [reducedMotion]: {
      transition: 'none',
    },
  },
});

export const triggerOpen = style({
  borderColor: vars.surface.border.accent,
});

export const badge = style({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '1px 6px',
  borderRadius: vars.spacing.borderRadius.xs,
  background: vars.surface.highlight.light,
  color: vars.typography.textColor.primary,
  fontSize: vars.typography.fontSize.xs,
  lineHeight: '1.4',
  whiteSpace: 'nowrap',
});

export const caret = style({
  flexShrink: 0,
  transition: `transform ${vars.animation.duration.fast}`,
  '@media': {
    [reducedMotion]: {
      transition: 'none',
    },
  },
});

export const caretOpen = style({
  transform: 'rotate(180deg)',
});

export const overlay = style({
  position: 'fixed',
  inset: 0,
  zIndex: vars.elevation.floatingAction,
});

export const dropdown = style({
  position: 'fixed',
  zIndex: vars.elevation.localOverlay,
  minWidth: '160px',
  padding: '4px 0',
  borderRadius: vars.spacing.borderRadius.sm,
  background: vars.surface.liquidGlass.innerSurface.background,
  backdropFilter: vars.surface.liquidGlass.backdropFilter.medium,
  border: `1px solid ${vars.surface.liquidGlass.innerSurface.border}`,
  boxShadow: `0 4px 12px ${vars.opacityScale.blackOverlay.medium}`,
});

export const checkboxRow = style({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 12px',
  cursor: 'pointer',
  minHeight: '44px',
  selectors: {
    '&:hover': {
      background: vars.surface.highlight.faint,
    },
  },
});

export const checkboxLabel = style({
  fontSize: vars.typography.fontSize.sm,
  color: vars.typography.textColor.primary,
  cursor: 'pointer',
  userSelect: 'none',
});
